import React, { memo, useContext } from 'react';
import { StateContext } from '../../contexts/stateContext';
import { WithVersion } from '../UiKit/VersionToggler';
import { pentaNarrativeComponents } from './narratives';

const CHANNEL_PAGES = ['penta_em', 'penta_same', 'penta_dom', 'penta_individual_channels'];
const VERSION_PAGES = ['penta_astrology', 'penta_jyotish'];
const BODY_PAGES = ['composite', 'compare'];

export const visiblePentaPages = (pages, { memberCount = 0, version, jyotishShown } = {}) =>
  (pages || []).filter((onePage) => {
    if (!onePage || !pentaNarrativeComponents[onePage.id]) return false;
    if (onePage.beta && version !== 'β') return false;
    if (!BODY_PAGES.includes(onePage.id) && memberCount < 2) return false;
    if (CHANNEL_PAGES.includes(onePage.id) && memberCount >= 3) return false;
    if (onePage.id === 'penta_jyotish' && !jyotishShown) return false;
    return true;
  });

export const PentaPages = memo(({
  penta,
  narrative,
  callback = () => void (0),
  compare = false,
  setCompare,
}) => {
  const context = { ...useContext(StateContext) };

  const memberCount = penta?.members?.length ?? 0;

  const pages = visiblePentaPages(narrative?.pages, {
    memberCount,
    version: context.state.version,
    jyotishShown: context.state.jyotishShown,
  });

  return (
    <>
      {pages.map((onePage) => {
        const showCompare = onePage.id === 'composite' && compare;
        const component = showCompare
          ? pentaNarrativeComponents.compare
          : pentaNarrativeComponents[onePage.id];
        let el = React.cloneElement(component, {
          ...component.props,
          penta,
          callback,
          id: onePage.id,
          compare,
          setCompare,
        });

        if (VERSION_PAGES.includes(onePage.id)) {
          el = <WithVersion>{el}</WithVersion>;
        }

        return (
          <div
            key={`page_${showCompare ? 'compare' : onePage.id}`}
            id={onePage.id}
            className={`x_edu_content0 x_edu_content0--penta x_edu_content0--${showCompare ? 'compare' : onePage.id}`}
          >
            {el}
          </div>
        );
      })}
    </>
  );
});
